import { FC } from 'react';
import styled from 'styled-components';
import AchievementBadge from '../AchievementBadge';
import { IAchievementBadge } from '../AchievementBadge/AchievementBadge';

const Container = styled.tr<{ highlight: boolean }>(({ theme, highlight }) => {
  const { color, type } = theme;

  return `
    padding: 7px 10px 7px 30px;
    width: 100%;
    font-family: ${type.face};
    font-size: ${type.size.tiny};
    color: ${color.grayscale[0]};
    line-height: ${type.size.small};

    td {
      padding: 7px;
      background-color: ${highlight ? color.secondary.regular : color.grayscale[900]};
      ${highlight ? `color: ${color.grayscale[1000]};` : ''}
    }
  `;
});

const NameContainer = styled.td(({ theme }) => {
  const { color } = theme;
  return `
    font-weight: bold;
    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: ${color.grayscale[800]};
    padding-left: 30px;
  `;
});

const Name = styled.div(({ theme }) => {
  const { type } = theme;
  return `
    font-size: ${type.size.small};
  `;
});

const Title = styled.div(({ theme }) => {
  const { type } = theme;
  return `
    font-size: ${type.size.tiny};
    font-weight: normal;
  `;
});

const Text = styled.td(({ theme }) => {
  const { color } = theme;

  return `
    justify-content: center;
    border-width: 1px 0;
    border-style: solid;
    border-color: ${color.grayscale[800]};
    text-align: center;
  `;
});

const BadgeWrapper = styled.td(({ theme }) => {
  const { color } = theme;
  return `
    max-height: 45px;
    text-align: right;
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: ${color.grayscale[800]};
    padding-right: 10px;
    text-align: right;
  `;
});

export interface IActivity {
  name: string;
  text: string;
  highlight: boolean;
  badge: IAchievementBadge;
  titleName?: string;
}

const Activity: FC<IActivity> = ({ text, badge, highlight, name, titleName }) => {
  return (
    <Container highlight={highlight}>
      <NameContainer>
        <Name>{name}</Name>
        <Title>{titleName}</Title>
      </NameContainer>
      <Text>{text}</Text>

      <BadgeWrapper>
        <AchievementBadge {...badge} />
      </BadgeWrapper>
    </Container>
  );
};

export default Activity;
